<template>
  <div class="card flex flex-wrap p-fluid">
    <div class="col-2">
      <div class="flex-auto">
            <label for="itemName" class="font-bold mb-2"> Name: </label>
            <InputText v-model="itemName" @change="bindData"/>
      </div>
    </div>
    <div class="col-1">
      <div class="flex-auto">
          <label class="font-bold mb-2"> Basic Rate: </label>
          <InputNumber v-model="itemBasic" inputId="itemBasic" @input="setBasic($event); bindData();" :minFractionDigits="2" :maxFractionDigits="4" locale="en-IN"/>
      </div>
    </div>
    <div class="col-1">
      <div class="flex-auto">
          <label  class="font-bold mb-2"> GST 2.0(%): </label>
          <InputNumber v-model="itemGst2" inputId="itemGst2" @input="setGst2($event); bindData();" :minFractionDigits="2" :maxFractionDigits="2" locale="en-IN"/>
          <label class="text-sm text-500 mt-2">GST: {{ formatCurrency(itemGst2Val) }}</label>
      </div>
    </div>
    <div class="col-1">
      <div class="flex-auto">
          <label  class="font-bold mb-2"> Rate 2.0: </label>
          <InputNumber v-model="itemNewRate" inputId="itemNewRate" @change="bindData" :minFractionDigits="2" :maxFractionDigits="4" locale="en-IN" readonly/>
          
      </div>
    </div>
    <!-- previously used for old gst regime -->
    <!-- <div class="col-1">
      <div class="flex-auto">
          <label for="itemRate" class="font-bold mb-2"> Rate: </label>
          <InputNumber v-model="itemRate" inputId="itemRate" @change="bindData" :minFractionDigits="2" :maxFractionDigits="3" locale="en-IN"/>
      </div>
    </div> -->
    <div class="col-1">
      <div class="flex-auto">
          <label for="itemPacking" class="font-bold mb-2"> Packing: </label>
          <InputText v-model="itemPacking"  @change="bindData"/>
      </div>
    </div>
    <div class="col-2">
      <div class="flex-auto">  
        <label for="itemCategory" class="font-bold mb-2">Category: </label>
          <TreeSelect v-model="selectedCategory" :options="categories" placeholder="Select Category" class="w-full" @change="bindData(), checkEquipmentCategory()"/>
      </div>
    </div>
    <div v-if="equipmentStatus" class="col-2" >
      <div class="flex-auto">
        <label for="installationStatus" class="font-bold mb-2">Installation Required:</label>
        <Dropdown size="small" v-model="selectedInstallationStatus" :options="installationOptions" optionValue="value" optionLabel="label" placeholder="Select a status" @change="bindData"/>
      </div>
    </div>
    <div class="col-2">
      <div class="flex-auto">
        <label for="manufacturer" class="font-bold mb-2">Manufacturer:</label>
        <Dropdown size="small" v-model="itemManufacturer" editable filter :options="manufacturers" optionValue="id" optionLabel="name" placeholder="Select Manufacturer" @change="bindData"/>
      </div>
    </div>
    <div class="col-1">
      <div class="flex-auto">
        <label class="font-bold mb-2">Sl No.:</label>
        <InputText v-model="itemSlNo" @change="bindData"/>
      </div>
    </div>
    <div class="col-1">
      <div class="field" >
        <label for="action" class="font-bold mb-2">Del:</label> 
        <div>
          <Button icon="pi pi-trash" size="small" severity="danger" raised @click="$emit('delete')" v-tooltip.top="'Delete item'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputText from 'primevue/inputtext'
import InputNumber from 'primevue/inputnumber'
import Dropdown from 'primevue/dropdown'
import Button from 'primevue/button'
import TreeSelect from 'primevue/treeselect'

export default {
  name:'RocItem',
    components:{ 
      InputText, 
      InputNumber, 
      Dropdown, 
      Button, 
      TreeSelect
      },

      props:{
        itemId:Number,
      categories: Array,
      manufacturers:Array
      },

    emits: ['delete', 'bind-item'],

    data(){
      return{
          itemName:null,
          itemRate:0, //set to zero by default after gst 2.0 - used for rate incl-gst during old gst regime
          itemBasic:0,
          itemGst2:0,
          itemGst2Val:0,
          itemNewRate:0,
          itemPacking:null,
          itemManufacturer:null,
          itemSlNo:null,
          selectedCategory:null,
          equipmentCategory:null,
          equipmentStatus:false,
          installationOptions:[
            {label:'No', value:'0'},
            {label:'Yes', value:'1'},
          ],
          selectedInstallationStatus:'0',
      }
    },

    methods:{
      bindData(){  
        if(this.selectedCategory!=null && (Object.keys(this.selectedCategory)[0] != this.equipmentCategory)){
          this.selectedInstallationStatus = '0';
        }
       const itemdata = {
              itemName:this.itemName,
              itemRate:this.itemRate,
              itemPacking:this.itemPacking,
              itemBasic:this.itemBasic,
              itemGst2:this.itemGst2,
              itemNewRate:this.itemNewRate,
              itemManufacturer:this.itemManufacturer,
              itemSlNo:this.itemSlNo,
              selectedCategory:this.selectedCategory,
              installationStatus:this.selectedInstallationStatus,
        }                
        this.$emit('bind-item', this.itemId, itemdata);
      },
      setBasic(event){
        this.itemBasic = event.value;        
        this.calInclGst2();
      },
      setGst2(event){ 
        this.itemGst2 = event.value;
        this.calInclGst2();
      },
      calInclGst2(){
        this.itemGst2Val = this.itemBasic * (this.itemGst2/100);
        this.itemNewRate = this.itemBasic + (this.itemBasic * (this.itemGst2/100));
      },
      checkEquipmentCategory(){
        if(Object.keys(this.selectedCategory)[0] == this.equipmentCategory){
          this.equipmentStatus = true;
        }else{
          this.equipmentStatus = false;
          this.selectedInstallationStatus = '0';
        }        
      },
      formatCurrency(value) {
        return value.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }, {maximumFractionDigits:4, minimumFractionDigits:2});
      },
    },

    mounted(){
      this.equipmentCategory = (this.categories.find(category => {
        if(category.label === 'Equipments' || category.label === 'Equipment' || category.label === 'EQUIPMENTS' || category.label === 'EQUIPMENT'){
          return category;
        }
      })).key;
    },
  
}
</script>

<style>

</style>